import { render, staticRenderFns } from "./ProjectInfo.vue?vue&type=template&id=169c581e&"
import script from "./ProjectInfo.vue?vue&type=script&lang=ts&"
export * from "./ProjectInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports